<template>
  <div id="app">
    <router-view/>
   
  </div>
</template>

<script>
export default {
  name: 'App',
   data () {
    return {
     
    }
  },
  
}
</script>

<style>
html,body{ width: 100%; height: 100%; overflow: scroll;}
html::-webkit-scrollbar, body::-webkit-scrollbar{width:0px;height:0px;}
body {
  -webkit-overflow-scrolling:touch;
  -webkit-text-size-adjust: none;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
.row:after{
    content: '';
    height: 0;
    display: block;
    clear: both;
  }
body{
  padding: 0;
  margin: 0
}
.red{color: red}
h1, h2 {
    font-weight: normal;
  }
  a{
    text-decoration: none;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
/* 弹出框 */
  .Safari{
    transform: all .3s;
  }
  .maskShow{
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1000;
    overflow: auto;
    outline: 0;
    background: rgba(158, 158, 158, .5);
    transform: all .3s;
  }
  .maskShow1{
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1000;
    overflow: auto;
    outline: 0;
    background: rgba(000, 000, 000, .8);
    transform: all .3s;
  }
  .Safari .main{
    z-index: 1001;
    position: absolute;
    width: 80%;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    transform: all .3s;
  }
  .main>div:first-child{background: linear-gradient(to top,#323335,#53565e);border-top-left-radius: 15px;border-top-right-radius: 15px;padding: 15px 0}
  .main>div:last-child{background: #fff;border-bottom-left-radius: 15px;border-bottom-right-radius: 15px;padding: 15px 0}
  .main-text div{float: left;height: 80px;line-height: 80px;color: #fff;}
  .main-text div:first-child{width: 35%;}
  .main-text div:last-child{width: 65%;text-align: left;position: relative;}
  .main-text div:last-child span{width: 85%;letter-spacing: 2px;margin-top: 18px;font-size: 15px}
  .main span{display: inline-block;}
  .main span{height: 30px;line-height: 23px;}
  .main img{width: 50%;vertical-align: middle;}
  .main .return1{position: absolute;width: 22px;top: -5px;right: 10px;}
  .main-url{background: #e1e1e1;height: 30px; width: 80%;margin: 0 auto;border-radius: 15px;font-size: 14px}
  .main-url span{float: left;height: 30px;line-height: 30px;display: inline-block;}
  .main-url span:first-child{width: 75%}
  .main-url span:last-child{width: 25%;background: linear-gradient(to top,#323335,#53565e);border-top-right-radius: 15px;border-bottom-right-radius: 15px;color: #fff;    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -moz-tap-highlight-color: rgba(0,0,0,0);
    -o-tap-highlight-color: rgba(0,0,0,0);
    -ms-tap-highlight-color: rgba(0,0,0,0);
  }
  .weixin{position: relative}
  .weixin-img{
    z-index: 1002;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    transform: all .3s;
  }
  .weixin-img img{width: 90%}
  /* iPad */
@media (min-width: 768px){
  .return span{font-size: 2rem;padding: 0 0px 0 49px;height: 34px;background-size: 34px;}
  .main .return1 {width: 44px;top: -20px;}
  .main>div:last-child,.main>div:first-child{padding:35px 0;}
  .main-text div{height: 110px;line-height: 110px;}
  .main-text div:last-child span{font-size: 2rem}
  .main span {line-height: 45px;}
  .main-url{height: 45px;font-size: 1.5rem}
  .main-url span{height: 45px;}
}
/* iPadpro */
@media (min-width:1024px){
  .Safari .main{width:70%}
  .main img {width: 40%;}
}
/* 5s */
@media (max-width: 320px){
  .main-text div:last-child span{width: 91%}
}
</style>



// WEBPACK FOOTER //
// src/App.vue